// Central BPA Verify. One reusable module; no OTP backend or provider key in this application.
const BASE=(import.meta.env.VITE_BPA_VERIFY_URL || 'https://bpa-verify-otp-service.netlify.app').replace(/\/$/,'');
const configuredAppId=String(import.meta.env.VITE_BPA_VERIFY_APP_ID||'').trim();
const APP_ID=(!configuredAppId||configuredAppId==='bpa-assessment-hub')?'bpas-assessment-hub':configuredAppId;
const ENABLED_PURPOSES=['email_verification'];
export const verifyConfigured=Boolean(BASE && APP_ID);
const friendlyError=(body,status)=>{
 const code=String(body.errorCode||body.code||'').toLowerCase();
 if(status===429||code.includes('rate'))return 'Too many verification attempts. Please wait, then request a new code.';
 if(code.includes('expired')||status===410)return 'This code is no longer valid. Request a fresh verification code.';
 if(code.includes('attempt'))return 'Too many incorrect attempts. Request a new code.';
 if(code.includes('incorrect')||code.includes('invalid')||code.includes('wrong'))return 'The code is incorrect. You can replace it and try again.';
 return String(body.error||body.message||'The verification service could not complete your request.');
};
async function request(path,payload) {
 let response;
 try {response=await fetch(BASE+path,{method:'POST',mode:'cors',cache:'no-store',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});}
 catch {
  throw new Error('Unable to connect to BPA Verify. Please check your connection and try Verify again. If the problem continues, contact BPA Solutions Support.');
 }
 const body=await response.json().catch(()=>({}));
 if(!response.ok||body.success===false||body.error)throw new Error(friendlyError(body,response.status));
 return body;
}
export function sendVerificationCode(email,purpose) {
 if(!ENABLED_PURPOSES.includes(purpose))throw new Error('Unsupported verification purpose.');
 return request('/api/send',{appId:APP_ID,email:String(email).trim().toLowerCase(),purpose});
}
export const requestEmailCode=email=>sendVerificationCode(email,'email_verification');
export function verifyEmailCode(challengeId,code) {
 return request('/api/verify',{appId:APP_ID,challengeId,code});
}